import React, {useState, useEffect} from 'react';
import {ContentHeader} from '@components';
import {Form} from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import QRCode from 'qrcode.react';
import {Button} from 'react-bootstrap';
import * as AuthService from '../services/auth';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import TableQr from './report/TableQr';

export default function Qr() {
  const [code, setCode] = useState('');
  const [qrData, setQrSData] = useState<any[]>([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const checkQR = async () => {
    try {
      const data = await AuthService.getQrData(code);
      if (data.error) throw 'timeout';
      console.log(data);
      setQrSData(data);
    } catch (error: any) {
      dispatch(logoutUser());
      navigate('/login');
    }
  };

  return (
    <div>
      <ContentHeader title="QR Checker" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-9">
              <Card>
                <Card.Header>Enter Code</Card.Header>
                <Card.Body>
                  <Form.Group className="mb-3 col-md-12">
                    <Form.Control
                      as="textarea"
                      // value={costCenter}
                      value={code}
                      placeholder={'Input code, number only!'}
                      onChange={(e) => {
                        setCode(e.target.value);
                      }}
                    />
                    <Button
                      className="mt-2"
                      variant="success"
                      onClick={checkQR}
                      disabled={code === ''}
                    >
                      Check QR
                    </Button>
                  </Form.Group>
                </Card.Body>
              </Card>
              <Card>
                <Card.Body>
                  <Form.Group className="mb-3 col-md-12">
                    <TableQr names={qrData} />
                  </Form.Group>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
